export const RecaptchaContainerId = 'recaptcha-container';
export const RecaptchaParentId = 'recaptcha-parent';
